import React, { Component } from "react";
import { Spin, Select } from "antd";
import axios from "axios";
import debounce from "lodash.debounce";
import './Styles.css';

const { Option } = Select;

// Debe coincidir con el $limit de empleados/selectEmpleadosItem
const EMPLEADOS_POR_PAGINA = 10;

class SelectEmpleadosItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opciones: [],
      cargando: false,
      primerCarga: false,
      texto: '',
      hayMas: true,
      // Se lleva aparte y no como opciones.length: la de-duplicacion hace crecer
      // la lista menos de una pagina y el skip se quedaria corto, repitiendo filas
      skip: 0,
    };
    // El scroll dispara muy seguido, no basta con state.cargando (se actualiza async)
    this.peticionEnCurso = false;

    this.buscarEmpleados = debounce(this.buscarEmpleados.bind(this), 300);
  }

  componentDidMount() {
    this.buscarEmpleados(this.props.value ? String(this.props.value) : '');
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      // Si el valor cambia, solo se recarga cuando falta el nombre de algun seleccionado.
      // Recargar siempre reiniciaba la lista a la primera pagina y tiraba el scroll ya cargado.
      if (this.props.value) {
        const valores = Array.isArray(this.props.value) ? this.props.value : [this.props.value];
        const faltantes = valores.filter((valor) => valor &&
          !this.state.opciones.some((empleado) => empleado._id.toString() === valor.toString()));
        if (faltantes.length === 1 && !Array.isArray(this.props.value)) {
          this.buscarEmpleados(faltantes[0].toString());
        } else if (faltantes.length > 0) {
          this.buscarEmpleados('');
        }
      }
    }
  }

  componentWillUnmount() {
    if (this.buscarEmpleados && this.buscarEmpleados.cancel) {
      this.buscarEmpleados.cancel();
    }
  }

  async buscarEmpleados(texto, append = false) {
    // El value puede ser un arreglo (mode multiple), no sirve como texto de busqueda
    const textoBusqueda = typeof texto === 'string' ? texto : '';

    // Al llegar al fondo no se encadenan peticiones ni se piden paginas que ya no existen
    if (append && (this.peticionEnCurso || !this.state.hayMas)) return;

    const skipActual = append ? this.state.skip : 0;

    this.peticionEnCurso = true;
    this.setState({ cargando: true });
    try {
      const res = await axios.post(
        "empleados/selectEmpleadosItem",
        {
          empresaId: this.props.empresaId,
          query: append ? this.state.texto : textoBusqueda,
          values: this.props.value,
          // Permite excluir el empleado actual (útil para líder directo)
          excluirId: this.props.excluirId,
          conDatosNomina: this.props.conDatosNomina || false, // <-- aquí
          // Opt-in: sin esto el endpoint sigue devolviendo sólo empleados activos
          incluirBajas: this.props.incluirBajas || false,
          skip: skipActual, // saltar los ya pedidos
        },
        { headers: this.props.headersToken }
      );

      if (res.data.success === 2) {
        const empleados = res.data.empleados || [];
        this.setState({
          // La inyeccion de `values` puede reenviar un seleccionado ya cargado: sin
          // deduplicar se repetiria la key del Option
          opciones: append ? this.unir(this.state.opciones, empleados) : empleados,
          primerCarga: true,
          texto: append ? this.state.texto : textoBusqueda,
          skip: skipActual + empleados.length,
          hayMas: empleados.length >= EMPLEADOS_POR_PAGINA,
        });
      } else {
        // Si falla una pagina del scroll no se pierde lo que ya estaba cargado
        this.setState({
          opciones: append ? this.state.opciones : [],
          primerCarga: true,
          texto: append ? this.state.texto : textoBusqueda,
          skip: skipActual,
          hayMas: false,
        });
      }
    } catch (error) {
      console.error("Error al buscar empleados:", error);
      this.setState({
        opciones: append ? this.state.opciones : [],
        texto: append ? this.state.texto : textoBusqueda,
        skip: skipActual,
        hayMas: false,
      });
    } finally {
      // Asegurar que siempre se quite el loading
      this.peticionEnCurso = false;
      this.setState({ cargando: false });
    }
  }

  unir(previas, nuevas) {
    const vistos = new Set(previas.map((e) => e._id.toString()));
    return [...previas, ...nuevas.filter((e) => !vistos.has(e._id.toString()))];
  }

  render() {
    // 1. Desestructura la nueva prop en el render y en la petición
    const {
      noBuscar, mode, disabled, fondoBlanco,
      sinBorde, width, style, placeholder,
      excluirId,
      conDatosNomina, // <-- nueva prop
      incluirBajas,
      ...restProps
    } = this.props;

    const propsNuevas = {
      showSearch: !noBuscar,
      filterOption: false,
      mode,
      onSearch: this.buscarEmpleados,
      notFoundContent: this.state.cargando ? (
        <div style={{ textAlign: "center", padding: "8px" }}>
          <div style={{ marginTop: "8px", fontSize: "12px", color: "#999" }}>
            Buscando empleados...
          </div>
        </div>
      ) : this.state.primerCarga ? "No se encontraron empleados" : null,
      loading: this.state.cargando,
    };

    if (mode === "multiple") propsNuevas.maxTagCount = "responsive";

    const estiloFinal = {
      color: disabled ? "black" : "inherit",
      backgroundColor: disabled ? "white" : null,
      borderBottom: sinBorde ? "none" : "1px solid #E0FFFFFF",
      borderRadius: "4px",
      transition: "border-color 0.3s ease",
      boxShadow: sinBorde ? "none" : "0 1px 3px rgba(0, 0, 0, 0.1)",
      width: width || undefined,
      opacity: disabled ? 1 : undefined,
      ...style,
    };

    return (
      <Select
        className={`custom-disabled-select ${disabled ? "custom-disabled" : ""}`}
        dropdownMatchSelectWidth={450}
        disabled={disabled}
        dropdownRender={(menu) => (
          <Spin spinning={this.state.cargando}>{menu}</Spin>
        )}
        {...propsNuevas}
        {...restProps}
        onChange={(value) => {
          const empleado = this.state.opciones.find((e) => e._id === value);
          this.props.onChange(value, empleado);
        }}
        placeholder={
          this.state.cargando && !this.state.primerCarga ? "Cargando..." : placeholder
        }
        style={estiloFinal}
        bordered={false}
        onPopupScroll={(e) => {
          const { target } = e;
          if (target.scrollTop + target.offsetHeight >= target.scrollHeight - 4) {
            // Llegaste al fondo -> cargar mas
            this.buscarEmpleados(this.state.texto, true);
          }
        }}
      >
        {this.state.opciones.map((empleado) => (
          <Option key={empleado._id} value={empleado._id}>
            {empleado.stringBuscar}
          </Option>
        ))}
      </Select>
    );
  }
}

export default SelectEmpleadosItem;